<template>
    <router-view />
</template>
<script>
export default {
    name: 'FlexRoute',

    beforeRouteUpdate(to, from, next) {
        if (to.name == 'flex') {
            next({ name: 'flex-list' });
        } else {
            next();
        }
    },
    created() {
        if (this.$route.name == 'flex') {
            this.$router.push({ name: 'flex-list' });
        }
    },
};
</script>
